import React, { useState } from 'react';
import { VStack, FormControl, } from 'native-base';
import { isSwitchEnvCode, useQaAgent, } from '@springbig/shared';
import { Caption, CaptionError, H3 } from '~/shared/Typography';
import { useAppNavigate } from '..';
import { Input, Button, FullScreenBox, Section } from '~/shared/Theme';

const PinScreen = () => {

    const { navigate } = useAppNavigate();
    const {
        setQaAgent
    } = useQaAgent();

    const [error, setError] =
        useState<Error | null>(null);

    const [pin, setPin] =
        useState<number | null>(null);

    const handleSubmit = () => {

        if (!isSwitchEnvCode(pin! * 1)) {

            setError(
                new Error(
                    'The secret pin you have entered is not correct. ' +
                    'Ask admin for more information.'
                )
            );
            return;
        }

        setQaAgent(true);
        navigate('auth/select-env');

    };

    const onChange = (text: string) => {

        setPin(Number(text));
    };

    return (
        <FullScreenBox>
            <Section p={4} fullScreen>
                <VStack justifyContent={'center'} flex={1} space={4}>
                    <H3>Enter Secret Pin</H3>

                    <CaptionError>{error && error.message}</CaptionError>

                    <FormControl isRequired isInvalid={!!error}>
                        <FormControl.Label>
                            <Caption text={'general.pin'} />
                        </FormControl.Label>
                        <VStack space={4}>
                            <Input
                                placeholder={'1234'}
                                maxLength={7}
                                onChangeText={onChange}
                                errors={error?.message || null}
                            />
                            <Button
                                text={'Submit secret'}
                                onPress={handleSubmit}
                            />
                        </VStack>
                    </FormControl>
                </VStack>
            </Section>
        </FullScreenBox>
    );
};

export default PinScreen;
